import { types } from "../action-types";

const initialState = {
  loading: false,
  details: [],
  error: false,
  placeBidData: []
};

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_FAVORITES_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_FAVORITES_SUCCESS: 
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      };
    case types.GET_FAVORITES_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      };
    case types.GET_BID_PLACE_PROPS:
      return {
        ...state,
        placeBidData: action.payload,
      }
    default:
      return state;
  }
};

export default favoritesReducer;
